/**
 * Console wrapper for JSON logging in Kubernetes
 * Initialize this at app startup to override console methods
 */

const originalConsole = {
  log: console.log,
  error: console.error,
  warn: console.warn,
  info: console.info,
  debug: console.debug,
};

function formatJson(level: string, args: any[]): string {
  const timestamp = new Date().toISOString();

  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null) {
    return JSON.stringify({
      timestamp,
      level,
      ...args[0],
    });
  }

  return JSON.stringify({
    timestamp,
    level,
    message: args
      .map((arg) => (typeof arg === "object" ? JSON.stringify(arg) : String(arg)))
      .join(" "),
  });
}

export function enableJsonLogging(): void {
  const format = (process.env.LOG_FORMAT || "text").toLowerCase();

  if (format !== "json") {
    return;
  }

  console.log = (...args: any[]) => {
    originalConsole.log(formatJson("info", args));
  };

  console.error = (...args: any[]) => {
    originalConsole.error(formatJson("error", args));
  };

  console.warn = (...args: any[]) => {
    originalConsole.warn(formatJson("warn", args));
  };

  console.info = (...args: any[]) => {
    originalConsole.info(formatJson("info", args));
  };

  console.debug = (...args: any[]) => {
    originalConsole.debug(formatJson("debug", args));
  };
}
